setTimeout(() => {
    let checkButton = document.querySelectorAll('.t4s-site-nav__icon.t4s-site-nav__cart.cart-container')
  console.log( checkButton)
    if (checkButton) {
        checkButton.forEach((e) => {
            e.addEventListener('click', () => {
                setTimeout(() => {
                   document.dispatchEvent(new Event(`bss_b2b:CustomCartUpdate`));
                      BSS_B2B.observer.cartSubject.notifyObserver('CartUpdate', 'CustomCartUpdate', {
                        event: e,
                    });
                }, 2000)
            })
        })
    }
}, 2500)